import { Sheet, SheetContent, SheetTrigger } from '@/components/shadcn/sheet'
import { cn } from '@/lib/utils'
import { Suspense, useState } from 'react'
import { SheetFormComponent } from '../../sheet-components'
import { StepperStepBody } from './StepperStepBody'
import { useStepperStepContext } from './StepperStepContext'

export function StepDataForm() {
  const [isOpen, setIsOpen] = useState(false)
  const { action, contentClassName, stepData } = useStepperStepContext()

  if (action.type !== 'data-form') return null

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <button type="button" className={cn(contentClassName)}>
          <StepperStepBody />
        </button>
      </SheetTrigger>
      <SheetContent className="!pointer-events-auto pr-0 lg:max-w-3xl">
        <Suspense fallback={<div>Loading...</div>}>
          <SheetFormComponent
            contentId={action.contentId}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            formData={Object.keys(stepData).length > 0 ? stepData : undefined}
          />
        </Suspense>
      </SheetContent>
    </Sheet>
  )
}
